/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { OnboardingToken } from '../types/onboarding';

/**
 * Check if onboarding have a valid setup for assurance portfolios.
 *
 * stakeholder => [assurancePortfolioIdOne, assurancePortfolioIdTwo]
 *   stakeholder role will be converted to "user" role for each assurance portfolio
 * verifier => [assurancePortfolioIdThree]
 *   verifier role will be converted to "admin" role for each assurance portfolio
 */
export function hasAssuranceConfig(onboardingToken: Partial<OnboardingToken> | OnboardingToken) {
  if (!onboardingToken.assuranceStakeholders) {
    return false;
  }

  // stakeholder = 'user' role, verifier = 'admin' role
  const { stakeholder = [], verifier = [] } = onboardingToken.assuranceStakeholders;

  return stakeholder.length > 0 || verifier.length > 0;
}
